import React ,{ useEffect }from 'react';
import { connect } from 'react-redux';
import { goToPage , reportDWH } from '../energySaleBlockSlice';

const SignatureIframe = (props) => {

  let { iframeUrl } = props.data;

  useEffect(() => {
    const handleEventInNewTab = (event) => {
      if (event.data.type === 'ESignStatus') {
        if (event.data.status === 'ok') {
          props.reportDWH({ actionType: 'Power of Attorney', status: 'Completed', messageText: 'Power of Attorney - Signed' });
          window.removeEventListener('message', handleEventInNewTab);
          props.goToPage('digitalSignaturePage')
        }
      }
    };
    window.addEventListener('message', handleEventInNewTab);

    return () => {
      window.removeEventListener('message', handleEventInNewTab);
    };
  }, []);


  return (
    <div className='iframe-container'>
      <iframe className='energy-signature-iframe' src={iframeUrl}></iframe>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.energySaleBlock,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(SignatureIframe);
